import type { IThemeSettings, ThemeKey } from '../types';

import { LEGACY_DARK_THEME_PATTERN_COLOR, LEGACY_DEFAULT_PATTERN_COLOR } from '../config';

const LEGACY_PATTERN_COLORS: Record<ThemeKey, string> = {
  light: LEGACY_DEFAULT_PATTERN_COLOR,
  dark: LEGACY_DARK_THEME_PATTERN_COLOR,
};

// Telegram's default chip colour is only ever stored for a theme with no wallpaper of the user's own, so a
// theme that has one keeps its colour even when it happens to equal that default
export function migrateLegacyPatternColors(
  themes: Partial<Record<ThemeKey, IThemeSettings>> | undefined,
  defaultThemes: Partial<Record<ThemeKey, IThemeSettings>>,
) {
  (Object.keys(LEGACY_PATTERN_COLORS) as ThemeKey[]).forEach((theme) => {
    const settings = themes?.[theme];
    if (!settings || settings.background || settings.backgroundColor) return;
    if (settings.patternColor !== LEGACY_PATTERN_COLORS[theme]) return;

    settings.patternColor = defaultThemes[theme]?.patternColor;
  });
}
